<template>
  <div class="d-grid gap-4">
    <BaseAccordion
      v-for="(employee, employeeIndex) in formatedEmployeesData.filter((i) => i.is_extra == 0)"
      :key="'employee_' + employeeIndex"
      type="employee"
      :text="employee.employee.first_name + ' ' + employee.employee.last_name"
      :name="{ first: employee.employee.first_name, last: employee.employee.last_name }"
      :image="employee.employee.photo"
      :show="employee.employee.is_active && !employee.employee.is_deleted ? {
        name: 'timeControlShowEmployee',
        params: { employeeId: employee.employee.id },
      } : null"
    >
      <template slot="head-buttons" v-if="!employee.employee.is_active || employee.employee.is_deleted">
        <IconsUsersStatus :status="employee.employee.is_deleted ? 'deleted' : 'blocked'" class="mr-2"/>
      </template>
      <BaseTableView :head="tableHead" :class="$vuetify.breakpoint.xlOnly ? 'employee' : ''">
        <template v-for="(work, workIndex) in employee.works">
          <TimeControlShowGridEmployeeItem
            :key="'employee_' + employeeIndex + '-work_' + workIndex"
            :item="work"
            :tableHead="tableHead"
            :is-block-opened="isWorkBlockOpened(employeeIndex, workIndex, false)"
            @toggle-block="onToggleWorkBlock(employeeIndex, workIndex, false)"
          />
          <tr
            v-if="work.selected_blocks && work.selected_blocks.length && isWorkBlockOpened(employeeIndex, workIndex, false)"
            :key="'employee_block_' + employeeIndex + '-work_' + workIndex"
            class="block-row"
          >
            <td colspan="3" class="block-row__cell">
              <div class="block-subtable-wrap">
                <table class="block-subtable">
                  <thead>
                    <tr>
                      <th>Block</th>
                      <th>Date</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(blockItem, blockItemIndex) in work.selected_blocks"
                      :key="'employee_block_' + employeeIndex + '-work_' + workIndex + '-item_' + blockItemIndex"
                    >
                      <td>{{ blockItem.block || '—' }}</td>
                      <td>{{ blockItem.date ? $formatDate(blockItem.date) : '—' }}</td>
                      <td>{{ formatBlockValue(blockItem.value, work.work_type) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </BaseTableView>
    </BaseAccordion>
    <div
      class="extraHeader f18 mt-4"
      :class="{ 'extraHeader--min': $vuetify.breakpoint.mdAndDown }"
      v-if="formatedEmployeesData.filter((i) => i.is_extra == 1).length"
    >
      {{ localStorage.translations.pages.statistic_project.tables['dopolnitelnye-resursy'] }}
    </div>
    <BaseAccordion
      v-for="(employee, employeeIndex) in formatedEmployeesData.filter((i) => i.is_extra == 1)"
      :key="'extra-employee_' + employeeIndex"
      type="employee"
      :text="employee.employee.first_name + ' ' + employee.employee.last_name"
      :name="{ first: employee.employee.first_name, last: employee.employee.last_name }"
      :image="employee.employee.photo"
      class="extra"
      :show="{
        name: 'timeControlShowEmployee',
        params: { employeeId: employee.employee.id },
      }"
    >
      <BaseTableView :head="tableHead">
        <template v-for="(work, workIndex) in employee.works">
          <TimeControlShowGridEmployeeItem
            :key="'extra-employee_' + employeeIndex + '-work_' + workIndex"
            :item="work"
            :tableHead="tableHead"
            :extra="true"
            :is-block-opened="isWorkBlockOpened(employeeIndex, workIndex, true)"
            @toggle-block="onToggleWorkBlock(employeeIndex, workIndex, true)"
          />
          <tr
            v-if="work.selected_blocks && work.selected_blocks.length && isWorkBlockOpened(employeeIndex, workIndex, true)"
            :key="'extra_employee_block_' + employeeIndex + '-work_' + workIndex"
            class="block-row"
          >
            <td colspan="3" class="block-row__cell">
              <div class="block-subtable-wrap">
                <table class="block-subtable">
                  <thead>
                    <tr>
                      <th>Block</th>
                      <th>Date</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(blockItem, blockItemIndex) in work.selected_blocks"
                      :key="'extra_employee_block_' + employeeIndex + '-work_' + workIndex + '-item_' + blockItemIndex"
                    >
                      <td>{{ blockItem.block || '—' }}</td>
                      <td>{{ blockItem.date ? $formatDate(blockItem.date) : '—' }}</td>
                      <td>{{ formatBlockValue(blockItem.value, work.work_type) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </BaseTableView>
    </BaseAccordion>
  </div>
</template>

<script>
import TimeControlShowGridEmployeeItem from 'components/timeControl/show/TimeControlShowGridEmployeeItem'
import IconsUsersStatus from "components/icons/users/IconsUsersStatus.vue";

export default {
  name: 'TimeControlShowGridEmployee',
  props: ['periods'],
  components: {IconsUsersStatus, TimeControlShowGridEmployeeItem},
  data() {
    return {
      openedBlocks: {},
    }
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages.statistic_project.tables['vid-rabot'],
        },
        {text: this.localStorage.translations.pages.statistic_project.tables['period']},
        {text: this.localStorage.translations.pages.statistic_project.tables['fakt']},
      ]
    },
    formatedEmployeesData() {
      let data = []
      for (let periodIndex in this.periods) {
        var period = this.periods[periodIndex]
        for (let employeeIndex in period.employees) {
          let employee = period.employees[employeeIndex]
          let employeeId = employeeIndex
          let obj = {}
          obj.works = []
          obj.employee = {
            first_name: employee.first_name,
            last_name: employee.last_name,
            photo: employee.photo,
            done: employee.done,
            id: employeeIndex,
            is_active: employee.is_active,
            is_deleted: employee.is_deleted,
          }
          let objWork = {}
          obj.is_extra = period.is_extra
          const checkEmployee = (obj) =>
            obj.employee.id === employeeId && obj.is_extra === period.is_extra

          if (data.findIndex(checkEmployee) === -1) {
            objWork.employee_done = employee.done
            objWork.start_date = period.start_date
            objWork.end_date = period.end_date
            objWork.end_date = period.end_date
            objWork.selected_blocks = Array.isArray(employee.selected_block)
              ? employee.selected_block
              : []
            objWork.done = period.done
            objWork.is_extra = period.is_extra
            objWork.employees_count = period.employees_count
            objWork.left_days = period.left_days
            objWork.planned_days = period.planned_days
            objWork.planned_work = period.planned_work
            objWork.work_type = period.work_type
            obj.works.push(objWork)
            data.push(obj)
          } else {
            const checkWork = (obj) => obj.id == periodIndex
            if (data[data.findIndex(checkEmployee)].works.findIndex(checkWork) === -1) {
              let objEmployeeReady = data[data.findIndex(checkEmployee)]
              objWork.employee_done = employee.done
              objWork.start_date = period.start_date
              objWork.end_date = period.end_date
              objWork.end_date = period.end_date
              objWork.selected_blocks = Array.isArray(employee.selected_block)
                ? employee.selected_block
                : []
              objWork.done = period.done
              objWork.is_extra = period.is_extra
              objWork.employees_count = period.employees_count
              objWork.left_days = period.left_days
              objWork.planned_days = period.planned_days
              objWork.planned_work = period.planned_work
              objWork.work_type = period.work_type
              objEmployeeReady.works.push(objWork)
            }
          }
        }
      }
      return data
    },
  },
  methods: {
    formatBlockValue(value, workType) {
      if (value === null || value === undefined || value === '') return '—'
      if (workType && workType.is_hourly === 0) {
        return this.$roundNumberToTenths(value) + ' ' + workType.measure
      }
      return this.$formatTime(this.$roundNumberToTenths(value))
    },
    getWorkBlockKey(employeeIndex, workIndex, isExtra) {
      return `${isExtra ? 'extra' : 'main'}_${employeeIndex}_${workIndex}`
    },
    isWorkBlockOpened(employeeIndex, workIndex, isExtra) {
      return !!this.openedBlocks[this.getWorkBlockKey(employeeIndex, workIndex, isExtra)]
    },
    onToggleWorkBlock(employeeIndex, workIndex, isExtra) {
      const key = this.getWorkBlockKey(employeeIndex, workIndex, isExtra)
      this.$set(this.openedBlocks, key, !this.openedBlocks[key])
    },
    onOpenItem(id) {
      this.$router.push({
        name: 'timeControlShowEmployee',
        params: { employeeId: id },
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep().extra.base-accordion {
  .base-accordion__head {
    background: #5e5e5e;
  }
}

:deep() .extraHeader {
  display: block;
  padding: 20px 0 20px 25px;
  border-spacing: 15px;

  &--min {
    padding: 0 5px !important;
  }
}

.employee {
  :deep() td {
    &:nth-child(1) {
      width: 300px !important;
    }
    &:nth-child(2) {
      width: 150px !important;
    }
    &:nth-child(3) {
      width: 100px !important;
    }
    &:nth-child(4) {
      width: 100px !important;
    }
    &:nth-child(5) {
      width: 100px !important;
    }
  }
}

.block-row {
  background: #f6fbff;

  td {
    width: 100% !important;
    max-width: none !important;
  }

  &__cell {
    color: #5e6a73 !important;
    font-size: 13px;
    padding: 8px 16px 10px 26px !important;
    box-sizing: border-box;
  }
}

:deep(.table_tile_view > tbody > tr.block-row),
:deep(.table_card_view > tbody > tr.block-row) {
  display: block !important;
  width: 100% !important;
  background: #f6fbff !important;
}

:deep(.table_tile_view > tbody > tr.block-row:hover),
:deep(.table_card_view > tbody > tr.block-row:hover) {
  background: #f6fbff !important;
}

:deep(.table_tile_view > tbody > tr.block-row > td),
:deep(.table_card_view > tbody > tr.block-row > td) {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  border-bottom: none !important;
}

:deep(.table_tile_view > tbody > tr.block-row > td:before),
:deep(.table_card_view > tbody > tr.block-row > td:before) {
  content: none !important;
  display: none !important;
}

.block-subtable {
  width: 100%;
  min-width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    text-align: left;
    padding: 6px 10px;
    border-bottom: 1px solid #e4edf2;
  }

  th {
    font-weight: 600;
    color: #5e6a73;
  }
}

.block-subtable-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 960px) {
  .block-row {
    &__cell {
      padding: 8px 10px !important;
    }
  }

  .block-subtable {
    min-width: 100%;

    th,
    td {
      padding: 6px 8px;
      font-size: 12px;
      word-break: break-word;
    }
  }
}
</style>
